import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setStoredToken } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      if (!m) { navigate("/login"); return; }
      const session_id = decodeURIComponent(m[1]);
      try {
        const r = await api.post("/auth/session", { session_id });
        if (r.data?.session_token) setStoredToken(r.data.session_token);
        // Clear hash and go home
        window.history.replaceState(null, "", "/");
        window.location.href = "/";
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center text-stone-400 text-sm">
      <span className="animate-pulse">Signing you in…</span>
    </div>
  );
}
